import { MELEE_TUNING, THROW_TUNING } from "../../../shared/combatTuning.js";

function generateSwords() {
  const swords = {};
  for (let level = 1; level <= 8; level++) {
    for (let variant = 1; variant <= 5; variant++) {
      const id = `sword_${level}_v${variant}`;
      swords[id] = {
        id,
        name: `Sword ${level}-${variant}`,
        level,
        variant,
        sprite: { atlas: "weapons", frame: id, anchor: { x: 20, y: -10 } },
        attacks: {
          slash: {
            hitbox: { ...MELEE_TUNING.slash.hitbox },
            damage: Math.max(10 + level * 5, MELEE_TUNING.slash.damage),
            activeWindow: { start: 0.25, end: 0.625 },
            duration: 400,
            effect: null,
          },
          kick: {
            hitbox: { ...MELEE_TUNING.kick.hitbox },
            damage: Math.max(15 + level * 5, MELEE_TUNING.kick.damage),
            activeWindow: { start: 0.25, end: 0.5 },
            duration: 400,
            effect: null,
          },
        },
        projectile: null,
      };
    }
  }
  return swords;
}

export const WEAPONS = {
  ...generateSwords(),
  food_throwable: {
    id: "food_throwable",
    name: "Food",
    sprite: { atlas: "food", frame: "icons_28_01", anchor: { x: 10, y: -15 } },
    attacks: {
      throw: {
        damage: 10,
        activeWindow: { start: 0.375, end: 0.375 },
        duration: 400,
        effect: null,
      },
    },
    projectile: {
      atlas: "food", frame: "icons_28_01",
      speed: THROW_TUNING.food_throwable.speed,
      lifetime: THROW_TUNING.food_throwable.lifetimeMs,
      w: THROW_TUNING.food_throwable.w,
      h: THROW_TUNING.food_throwable.h,
      impactEffect: null,
    },
  },
};

export const DEFAULT_MELEE_WEAPON = "sword_1_v1";
export const DEFAULT_THROW_WEAPON = "food_throwable";
